module.exports = __webpack_public_path__ + "img/PL08689.39f19f9c.png";